const ErrorMessage=(props)=>{
    return(
        <>
        {props.label && <div className="invalid-feedback d-block f-s12">{props.label}</div>}
        </>
    )
}
export default ErrorMessage;